import { memo, Suspense, useEffect, useState, type FC } from "react";

import { AntProvider } from "./AntProvider";
import { AuthProvider } from "./AuthProvider";
import { Routes } from "./Routes";
import { StorageProvider } from "./StorageProvider";
import { ErrorBoundary } from "./ErrorBoundary";

import { LoadingPage } from "@/pages/loading";

import "./activeTracker";
import "./i18n";
import "./index.less";
import NoConnection from "@/pages/no-connection";

const App: FC = memo(() => {
  const [isOffline, setIsOffline] = useState(false);

  const handleOfflineEvent = () => {
    setTimeout(() => {
      if (!navigator.onLine) {
        setIsOffline(true);
      }
    }, 3000);
  };

  const handleRecheckConnection = () => {
    if (navigator.onLine) {
      setIsOffline(false);
    }
  };

  useEffect(() => {
    window.addEventListener("offline", handleOfflineEvent);

    return () => {
      window.removeEventListener("offline", handleOfflineEvent);
    };
  }, []);

  return (
    <ErrorBoundary>
      <StorageProvider>
        <AuthProvider>
          <AntProvider>
            <Suspense fallback={<LoadingPage />}>{!isOffline ? <Routes /> : <NoConnection handleRecheckConnection={handleRecheckConnection} />}</Suspense>
          </AntProvider>
        </AuthProvider>
      </StorageProvider>
    </ErrorBoundary>
  );
});

export default App;
